/**
 * The Add button's words, in one place (Joni, GH #2420). The picker only takes audio, so the labels say
 * audio: "Upload file" over an audio-only picker is a promise it breaks. Pending the user's OK on the changed
 * string; a different answer is a one-line change here.
 */
export const addMediaLabels = {
  /** The FAB that opens Record · Upload */
  addWithRecord: 'Record or upload audio',
  /** The menu item, and the FAB itself when uploading is the only action */
  upload: 'Upload audio',
  record: 'Record',
  /** A song's FAB, which also adds a chord (GH #2488). Pending the user's OK on new copy */
  addToSong: 'Add to song',
} as const
